<div class="row mb-1">
  <div class="col-" *ngIf="!_isClosed">
    <label class="ml-3"> Add/Remove:</label>
    <span matTooltip="Add/Remove charges" class="me-2 pe-2 icon-mat" (click)="add()">
      <i class="bi bi-plus-slash-minus"></i>
    </span>
  </div>
</div>
<div class="row mb-1">
  <div class="col-span-full">
    <mat-chip-list #chipList aria-label="charge selection">
      <mat-chip *ngFor="let charge of selectedCharges; index as i">
        {{ charge.type_label }} : {{ charge.type_value }}
        <i class="bi bi-x icon-close" (click)="remove(charge)" *ngIf="!_isClosed"></i>
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
